import React, {
  useEffect,
  useState,
  useRef,
  useContext,
} from "react";
import { withRouter } from "react-router";
import { XBEconfMobile } from "./XBEconfMobile";
import { XBEconfWeb } from "./XBEconfWeb";
import { XBEconfWeb2 } from "./XBEconfWeb2";
import {
  BrowserRouter as Router,
  Link,
  useLocation
} from "react-router-dom";
import { PAbluePage } from './PAblue';

import { XbeContext } from './CardsPage';





export const XBEconfInner = (props) => {

  const {
    type = 'web',
    language='en',
    filters,
    handleFilters,
    history,
    children,
  } = {...props}

  const context = useContext(XbeContext);


  const scrollToRef = (ref) => {
    if (ref.current) {
      console.log('ref.current.height = ', ref.current.height);
      console.log('ref.current.offsetTop = ', ref.current.offsetTop);
      // debugger
      // window.scrollTo(0, ref.current.offsetTop - ref.current.height)
      // window.scrollTo(0, 300)
    }
  }

  const contentRef = useRef(null)
  const executeScroll = () => scrollToRef(contentRef)

  const [f, setF] = useState()


  const applyFilters = newFilters => {
    // query.set('query', {'filters': newFilters.toString()})
    // const url = setParams({filters: newFilters.toString()});
    history.push(`?filters=${newFilters.toString()}`)
    console.log('newFilters.toString() = ', newFilters.toString());
    executeScroll();
    handleFilters(newFilters);
  }




  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }


  let query = useQuery();


  useEffect(() => {

    console.log('props[history = ', history);
    // if (filters) return
    if (query && query.get('filters') && !f) {

      // return
      console.log('query = ', query.get("filters"));
      let queryArray = query.get('filters').split(',');
      // console.log(queryArray.every(e => filters.includes(e)));
      if (queryArray.length === filters.length && queryArray.every(e => filters.includes(e))) {

      } else {

        // if (!queryArray || filters.filter(x => !queryArray.includes(x)).length) {
          // debugger
          setF(queryArray)
          handleFilters(queryArray)
        // }

      }
    }

    if (query && query.get('edit')) {
      console.log('query = ', query.get("edit"));
      context['setEditId'](query.get('edit'))
      console.log('query.get(\'edit\') = ', query.get('edit'));
    } else {
      context['setEditId']()
    }


  }, [query])


  const handleFilter = (filter) => {
    if (!filters) return;
    let newFilters = filters.slice();

    if (filter === 'all') {
      newFilters = addEntry('live_game', newFilters);
      newFilters = addEntry('pre_launch', newFilters);
      newFilters = addEntry('early_access', newFilters);
      applyFilters(newFilters);
      console.log('newFilters = ', newFilters);
      return
    }

    if (['live_game', 'pre_launch', 'early_access'].indexOf(filter) !== -1) {
      newFilters = deleteEntry('live_game', newFilters);
      newFilters = deleteEntry('pre_launch', newFilters);
      newFilters = deleteEntry('early_access', newFilters);
      newFilters = addEntry(filter, newFilters);
      applyFilters(newFilters);
      console.log('newFilters = ', newFilters);
      return
    }


    if (newFilters.indexOf(filter) !== -1) {

      const checkIfLastOfaKind = (filter, arr) => {
        //Check if its not the last one
        let intersection = arr.filter(x => filters.includes(x));
        if (intersection.length === 1 && intersection[0] === filter) {
          return false
        } else {
          return true
        }
      }

      if (['premium', 'microtransactions', 'subscriptions'].indexOf(filter) !== -1) {
        if (checkIfLastOfaKind(filter, ['premium', 'microtransactions', 'subscriptions'])) {
          newFilters = deleteEntry(filter, newFilters)
        } else {
          //not remiving, it's the last filter of a kind
        }
      }

      if (['pc_mac', 'web', 'console', 'mobile'].indexOf(filter) !== -1) {
        if (checkIfLastOfaKind(filter, ['pc_mac', 'web', 'console', 'mobile'])) {
          newFilters = deleteEntry(filter, newFilters)
        } else {
          //not remiving, it's the last filter of a kind
        }
      }


    } else {
      newFilters = [...newFilters, filter]
    }

    applyFilters(newFilters)
    console.log('newFilters = ', newFilters);
  }


  const addEntry = (filter, filters) => {
    let newFilters = filters.slice();
    let ind = newFilters.indexOf(filter);
    if (ind === -1) {
      newFilters = [...newFilters, filter]
    }
    return newFilters;
  }




  const deleteEntry = (filter, filters) => {
    let newFilters = filters.slice();
    let ind = newFilters.indexOf(filter);
    if (ind !== -1) {
      newFilters.splice(ind, 1)
    }
    return newFilters;
  }


  const checkIfShow = (filter) => {
    if (!filters) return;
    let ret = false;

    if (filter === 'all') {
      if (
        (filters.indexOf('live_game') !== -1) &&
        (filters.indexOf('pre_launch') !== -1) &&
        (filters.indexOf('early_access') !== -1)
      ) {
        return true;
      } else {
        return false;
      }
    }

    if (['live_game', 'pre_launch', 'early_access'].indexOf(filter) !== -1) {
      //Check if it's stage and if all stages
      if (
        (filters.indexOf('live_game') !== -1) &&
        (filters.indexOf('pre_launch') !== -1) &&
        (filters.indexOf('early_access') !== -1)
      ) {
        return false;
      }
    }

    return filters.indexOf(filter) !== -1 ? true : ret

  }




  if (type === 'web') {return (
    <XBEconfWeb
      handleFilter={handleFilter}
      checkIfShow={checkIfShow}
    >
      {children}
    </XBEconfWeb>
  )}

  if (type === 'web2') {return (
    <XBEconfWeb2
      language={language}
      handleFilter={handleFilter}
      checkIfShow={checkIfShow}
    >
        {children}

      </XBEconfWeb2>
  )}


  if (type === 'pa') {return (
    <PAbluePage
      language={language}
      handleFilter={handleFilter}
      checkIfShow={checkIfShow}
    />
  )}

  if (type === 'mobile') {
    return (
      <XBEconfMobile
        language={language}
        handleFilter={handleFilter}
        checkIfShow={checkIfShow}
      >
        <div
          ref={contentRef}
          >
          {children}
        </div>
      </XBEconfMobile>
    )
  }
}



export const XBEconf = withRouter(XBEconfInner);